module.exports = __webpack_public_path__ + "src/assets/games/30/92.jpg";